import gql from 'graphql-tag'

export const adminSetSubscriptionStatus = gql`
  mutation AdminSetSubscriptionStatus($input: AdminSetSubscriptionStatusInput!) {
    adminSetSubscriptionStatus(input: $input) {
      success
      deviceId
      deviceName
      status
      validFrom
      validTo
      daysFromNow
      minutesFromNow
      subscriptionId
    }
  }
`
